<template>
  <router-link :to="url" class="owal navigation card container">
    <div class="owal navigation card content">
      <h2 class="owal-navigation-icon__container">
        <div class="owal-navigation-icon__circle">
          <font-awesome-icon class="icon fa-fw" :icon="['fal', icon]" transform="fixed-width" style="font-weight: bold;" />
          </div>
          {{ title }}
      </h2>
    </div>
  </router-link>
</template>

<script>
import navigationItem from '@/components/shared/NavigationItem'
import { mockDashboardStats } from '@/libraries/util/mockDashboardStats'

export default {
  name: 'NavigationCard',
  mixins: [navigationItem],
  computed: {
    showStats: function () {
      return false // Hard coded, since we are killing this flag.
    },
    warningStats: function () {
      let warning = mockDashboardStats.stats[this.title].warning
      return warning
    },
    dangerStats: function () {
      let danger = mockDashboardStats.stats[this.title].danger
      return danger
    },
    lastAlerts: function () {
      let latestAlert = mockDashboardStats.stats[this.title].latestAlerts
      return latestAlert
    },
  },
}
</script>

<style scoped>
#searchbox {
  width: 100%;
  padding: 0 0.75rem 0 0.75rem;
}

.owal-navigation-icon__container {
  text-align: center;
  padding-bottom: 1rem;
}

.owal-navigation-icon__circle {
  border-radius: 50%;
  padding: 1rem;
  margin-bottom: 0.5rem;
  background: rgba(71, 86, 105, 0.05);
  border: 2px solid #475669;
}

.owal.navigation.card.container {
  width: 320px;
  height: 200px;

  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;

  margin: auto 1.5rem;

  background: rgba(239, 242, 247, 1);
  border: 2px solid #c0ccda;
  box-shadow: 0 0px 5px 10px rgba(71, 86, 105, 0.25);
  -webkit-box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.25),
    0px 30px 60px -20px rgba(239, 242, 247, 0.1);
  -moz-box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.25),
    0px 30px 60px -20px rgba(239, 242, 247, 0.1);
  box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.25),
    0px 30px 60px -20px rgba(239, 242, 247, 0.1);
  border-radius: 4px;

  transition: all 300ms ease;
  -webkit-animation: grow-in 0.7s ease-out 0 1 normal;
  animation: grow-in 0.7s ease-out 0 1 normal;
  padding: 0;
}

.owal.navigation.card.container:hover {
  background: #eff2f7;
  border: 2px solid #c0ccda;
  -webkit-box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.5),
    0px 30px 60px -20px rgba(239, 242, 247, 0.2);
  -moz-box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.5),
    0px 30px 60px -20px rgba(239, 242, 247, 0.2);
  box-shadow: 0px 30px 60px -20px rgba(71, 86, 105, 0.5),
    0px 30px 60px -20px rgba(239, 242, 247, 0.2);
  border-radius: 4px;
}

.owal.navigation.card.content {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
}

.owal.navigation.card.content h2 {
  font-family: 'Lato-Regular', 'Avenir', sans-serif;
  font-size: 2.57rem;
  color: #475669;
  letter-spacing: 0;
  transition: all 300ms ease;
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.owal.navigation.card.content h2 .owal-navigation-icon__circle {
  font-size: 2.5rem;
  box-shadow: 0px 2px 2px rgba(71, 86, 105, 0.25);
  text-shadow: none;
  background-color: none;
  transition: all 300ms ease;
}

.owal.navigation.card.content:hover h2 .owal-navigation-icon__circle {
  box-shadow: 0px 2px 2px rgba(71, 86, 105, 0.15);
}

/* Smaller screens than tablet landscape need to stack, and show smaller buttons. */
@media only screen and (max-width: 1023px) {
  .owal.navigation.card.container {
    transform: scale(0.8);
    margin: 0.25rem auto;
  }

  .owal.navigation.card.container:hover {
    transform: scale(0.98);
    margin: 0.5rem auto;
  }

  /* ------ Animations -------- */

  /* Animate the links/images into place. */
  @-webkit-keyframes grow-in {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.3);
      transform: scale(0.3);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes grow-in {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.3);
      transform: scale(0.3);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(0.8);
      transform: scale(0.8);
    }
  }
}

/* Tablet landscape and larger. */
@media only screen and (min-width: 1024px) {
  .owal.navigation.card.container {
    margin: auto 1.5rem;
  }

  .owal.navigation.card.container:hover {
    transform: translateY(-1rem);
    /* margin: auto 3rem; */
  }

  /* ------ Animations -------- */

  /* Animate the links/images into place. */
  @-webkit-keyframes grow-in {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.3);
      transform: scale(0.3);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes grow-in {
    0% {
      opacity: 0;
      -webkit-transform: scale(0.3);
      transform: scale(0.3);
    }

    100% {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
}
</style>
